/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
import React from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Divider from "@mui/material/Divider";
import CloseIcon from "./assets/Close-Icon.svg";

const Transition = React.forwardRef((props, ref) => {
  return <Slide direction='up' ref={ref} {...props} />;
});

const DisclaimerPopUp = (props) => {
  const { openDisclaimer } = props;
  const [open, setOpen] = React.useState(openDisclaimer);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby='disclaimer-dialog'
      data-testid='disclaimer-dialog'
      sx={{ borderRadius: "8px 8px 0px 0px" }}
    >
      <DialogTitle
        sx={{
          background: "#433182",
          color: "white",
          display: "flex",
          justifyContent: "space-between"
        }}
      >
        <span>Disclaimer</span>
        <button
          onClick={handleClose}
          style={{ cursor: "pointer" }}
          tabIndex={0}
          type='button' // Explicitly set the type attribute
        >
          <img src={CloseIcon} alt='close_icon' />
        </button>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "32px 16px 16px 16px"
        }}
      >
        <DialogContentText
          id='alert-dialog-slide-description'
          sx={{ paddingTop: "20px" }}
        >
          Any modifications made to this term sheet will not be applied until it
          is 'Sent' to the borrower.
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: "flex-start", padding: "16px" }}>
        <Button variant='outlined' onClick={handleClose}>
          Cancel
        </Button>
        <Button variant='contained' onClick={handleClose}>
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DisclaimerPopUp;
